var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message"},[_c('v-alert',{attrs:{"show":"","type":"success"}},[_vm._t("default",[_vm._v("Info message, please fill in the slot")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }